import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import GreenSwitch from '../../CustomizedUIs/GreenSwitch';

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        borderRadius: theme.spacing(4),
        width: 200,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.palette.background.paper
    },
    TitleSwitch: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: 9,
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '11px',
        letterSpacing: '0.36px',
        color: '#4f5064',
    },
}));

function SwitchBox({ label, checked, onChange, disabled, ...props }) {
    const classes = useStyles();

    return (
        <Box className={classes.container} {...props}>
            <Box flexGrow={1}>
                <Typography className={classes.TitleSwitch}>{label}</Typography>
            </Box>
            <GreenSwitch
                disabled={disabled}
                onChange={onChange}
                size='small'
                checked={checked}
            />
        </Box>
    )
}

export default SwitchBox;
